// elements/ButtonComponent.jsx
import React, { useState } from 'react';
import { useTheme } from '../themes/ThemeProvider';

const ButtonComponent = ({ id, label, variant = 'primary', onClick, readyState, isProcessing }) => {
  const { theme } = useTheme();
  const [ isHovered, setIsHovered ] = useState(false);
  // const [ timedReadyLabel, setTimedReadyLabel ] = useState('');

  const buttonStyle = theme.button?.[variant] + ' mt-2' || 'bg-blue-500 text-white px-3 py-1 rounded';
  const readyButtonStyle = theme?.readyButton + ' mt-2' || 'bg-green-950 text-white px-3 py-1 rounded';
  
  return (
    <button 
      className={`${!isProcessing && readyState ? readyButtonStyle : buttonStyle}`}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {readyState & !isHovered  ? "Ready" : label}
    </button>
  );
};

export default ButtonComponent;